// import jquery from 'jquery'
import tether from 'tether'
import bootstrap from 'bootstrap'

import lodash from 'lodash';
import './scss/style.scss';
import Vue from 'vue'
import App from './App'
import router from './router'
import googleAnalytics from './googleAnalytics.js'



Vue.config.productionTip = false

////////////////////////////////////////////////////////////////////////////////////
// Custom Google Analytics injection. Modified from vue-ga
////////////////////////////////////////////////////////////////////////////////////
window['NODE_ENV'] = process.env.NODE_ENV
if (NODE_ENV === 'production') {

  googleAnalytics ('UA-10798495-22','ICJIA | ', router)
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js